import { DashboardComponent } from "~/components/admin/dashboard/dashboard";
import PageMeta from "~/components/common/meta";

export function ScreenDashboard() {
  return (
    <>
      <PageMeta title="Dashboard | Art Handler" description="Dashboard" />
      <DashboardComponent />
    </>
  );
}
